const PALETTE = ['#60A5FA', '#6FDC8A', '#9F8BDB', '#FFC83D', '#FF8F8F', '#FF9F43', '#4DD4E5', '#2DD4BF', '#D1D5DB'];

export const chartColor = {
  meaning: {
    '사람·사회': PALETTE[0],
    '놀이·여가': PALETTE[1],
    '음식·생활': PALETTE[2],
    '사물·도구': PALETTE[3],
    '신체·상태': PALETTE[4],
    '감정': PALETTE[5],
    '동작': PALETTE[6],
    '개념·관계': PALETTE[7],
    '기타': PALETTE[8]
  },
  wordType: {
    '명사': PALETTE[0],
    '동사': PALETTE[1],
    '형용사': PALETTE[2],
    '부사': PALETTE[3],
    '대명사': PALETTE[4],
    '표현/감정': PALETTE[5],
    '수사': PALETTE[6],
    '고유명사': PALETTE[7],
    '기타': PALETTE[8]
  },
  communication: {
    '요구': PALETTE[0],
    '거절': PALETTE[1],
    '선택/지시': PALETTE[2],
    '주의끌기': PALETTE[3],
    '질문': PALETTE[4],
    '감정표현': PALETTE[5],
    '사회적 상호작용': PALETTE[6],
    '기타': PALETTE[8]
  },  
}